import * as ko from "knockout";
import Guid from "./guid";
function InfoAttachment() {
    var self = this;
    self.InfoAttachmentId = ko.observable(Guid());
    self.InfoId = ko.observable();
    self.Revision = ko.observable();
    self.Description = ko.observable();
    self.DeleteInRevision = ko.observable(null);
    self.dirtyExtender = {};
}
;
export default InfoAttachment;